import { BRANDS_CATEGORY_ID } from "@faire/help-center-utils/consts/BRANDS_CATEGORY_ID";
import { RETAILERS_CATEGORY_ID } from "@faire/help-center-utils/consts/RETAILERS_CATEGORY_ID";
import { CustomerTypes } from "@faire/help-center-utils/enums/CustomerType";

import { useCustomerType } from "@faire/help-center-utils/hooks/useCustomerType";

export const useZDCategoryId = () => {
  const { customerType } = useCustomerType();
  if (customerType === CustomerTypes.BRAND) {
    return BRANDS_CATEGORY_ID;
  } else {
    return RETAILERS_CATEGORY_ID;
  }
};
